import React from 'react';
import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack900Base, colorBlackTransparent50, colorCoreGray300, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const DropDownStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  margin-bottom: 32px;
  align-self: center;
`;
export const DropDownActiveElementStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 16px;
  cursor: pointer;
  width: 100%;

  border-radius: ${CORNER_RADIUS.s};
  border: 1px solid ${colorCoreBlack900Base};
  color: ${colorCoreBlack900Base};
`;
export const DropDownListWrapperStyled = styled.div `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 8px;
  position: absolute;
  top: 100%;

  display: ${({ isDropDownExpanded }) => (isDropDownExpanded ? 'flex' : 'none')};

  border: 1px solid ${colorCoreGray300};
  background-color: ${colorCoreWhite1000};
  border-radius: ${CORNER_RADIUS.m};
  z-index: ${Z_INDEX.level2};
`;
export const DropDownListStyled = styled.ul `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style: none;

  box-shadow: ${elevationBottomLvl2};
  border-radius: ${CORNER_RADIUS.m};

  ${({ withScroll }) => (withScroll ? CustomScroll : 'padding: 6px;')}
`;
export const DropDownItemStyled = styled.li `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  display: flex;
  flex-direction: row;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  padding: 10px 12px;
  width: 100%;
  cursor: pointer;

  border-radius: ${CORNER_RADIUS.xs};
  background-color: ${({ isActiveTab }) => isActiveTab ? colorBlackTransparent50 : defaultTransparent};
  color: ${colorCoreBlack900Base};
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SVGIconStyled = styled(({ isDropDownExpanded, ...props }) => React.createElement(SVGIcon, { ...props })) `
  ${({ isDropDownExpanded }) => isDropDownExpanded ? 'transform: rotate(0deg);' : 'transform: rotate(180deg);'}
`;
